import { atom } from 'recoil';
import sessionStorageEffect from '../effects/sessionStorageEffect';

const KEY = 'subscriptionTypeAtom';

export default atom({
  key: 'subscriptionTypeAtom',
  default: 'premium',
  effects: [
    sessionStorageEffect(KEY),
  ],
});
